import { Card, Page } from "@common";
import { useAuth } from "@api/useAuth";

export default function Welcome() {
  const { user } = useAuth();

  return (
    <Page>
      <Card className="max-w-2xl mx-auto mt-12">
        <div className="text-center py-8">
          <div className="mb-6">
            <span className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-palette-indigo-muted text-palette-indigo-badge text-2xl font-bold mb-4">
              👋
            </span>
          </div>

          <h1 className="text-3xl font-bold text-palette-gray-primary mb-4">
            Welcome, {user?.full_name || user?.email}!
          </h1>

          <p className="text-lg text-palette-gray-badge mb-6">
            Thank you for joining our platform.
          </p>

          <div className="bg-palette-indigo-soft border border-palette-indigo-border rounded-lg p-6 text-left">
            <h2 className="text-lg font-semibold text-palette-gray-primary mb-3">
              Getting Started
            </h2>
            <p className="text-palette-gray-heading mb-4">
              Your account has been successfully created, but you haven't been assigned to a clinic
              yet. To access the reporting and scheduling features, you'll need clinic access
              permissions.
            </p>
            <p className="text-palette-gray-heading">
              Please contact your administrator to assign you the appropriate role and clinic
              access. Once your permissions are configured, you'll be able to access all available
              features.
            </p>
          </div>

          <div className="mt-8 pt-6 border-t border-palette-gray-divider">
            <p className="text-sm text-palette-gray-secondary">
              Need help? Contact your system administrator for assistance.
            </p>
          </div>
        </div>
      </Card>
    </Page>
  );
}
